import React, { useEffect } from 'react';
import ReactTable from '../components/ReactTable';
import fetchFromAthena from '../functions/FetchFromAthena'
import { useRateCols } from '../hooks/EmployeeCols';


export default function EmployeeAltRates(props) {
    const [isLoading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([]);

    const rateCols = useRateCols();

    useEffect(() => {
        getData()
    }, [props.employee, props.company])

    const getData = async () => {
        setLoading(true)
        const data = await fetchFromAthena({
            queryName: 'employee_pay_rate',
            headers: {
                company: props.company,
                employee: props.employee
            },
            accessToken: props.fetchInitialData.credentials.user.accessToken,
            credentials: props.fetchInitialData.credentials
        })
        setLoading(false)
        setData(data)
    }

    return (
        <div>
            <ReactTable isLoading={isLoading} cols={rateCols} data={data} />
        </div>
    );
}
